import { render } from "./UserRoles.vue?vue&type=template&id=38a33308&ts=true"
import script from "./UserRoles.vue?vue&type=script&lang=ts"
export * from "./UserRoles.vue?vue&type=script&lang=ts"

import "./UserRoles.vue?vue&type=style&index=0&id=38a33308&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__